export const modelListMixin = {
    data() {
        return {
            loading: {
                data: false,
                search: false
            },
            data: null,
            filters: {
                query : '',
                limit : 15,
                sort: '',
                dir: 'asc',
                page : 1
            }
        };
    },
    methods: {
        getPage(page) {
            this.filters.page = page;
            this.getData();
        },
        search() {
            this.filters.page = 1;
            this.loading.search = true;
            this.getData();
        },
        setFilterDates(data) {
            for(const key in data) {
                this.filters[key] = data[key];
            }
        },
        setSort (field) {
            this.filters.page = 1;
            if (this.filters.sort === field) {
                this.filters.dir = this.filters.dir === 'asc' ? 'desc' : 'asc';
            }else{
                this.filters.sort = field;
            }

            this.getData();
        },
    }
}

